<template>
  <StatusBall
    :status-mapping="statusMapping"
    :status="status"
  />
</template>

<script>
import StatusBall from '@/components/common/status-ball/StatusBall.vue';
import eventStatusConstants from '@/data/event-constants/eventStatusConstants';

export default {
  name: 'EventStatusBall',
  components: { StatusBall },
  props: {
    status: {
      type: [String, Number],
      default: eventStatusConstants.STATUS_ACTIVE.key,
    },
  },
  data() {
    return {
      statusMapping: (status) => {
        if ([eventStatusConstants.STATUS_ACTIVE.key, eventStatusConstants.STATUS_ACTIVE.value].includes(status)) return 'active';
        if ([eventStatusConstants.STATUS_DRAFT.key, eventStatusConstants.STATUS_DRAFT.value].includes(status)) return 'draft';
        return 'other';
      },
    };
  },
};
</script>
